import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { AdminEmailRegEx, RoleName } from 'src/app/@shared/constants/Constant';
import { IAssignRoleViewModel, IRoleViewModel } from 'src/app/model/RoleViewModel';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { HeaderService } from 'src/app/service/header.service';
import { MemberService } from 'src/app/service/member.service';
import { IAssignedRole, ViewMemberModel } from 'src/app/service/memeber.model';
import { VendorService } from 'src/app/service/vendor.service';

@Component({
  selector: 'app-reassign-role-dialog',
  templateUrl: './reassign-role-dialog.component.html',
  styleUrls: ['./reassign-role-dialog.component.css'],
})
export class ReassignRoleDialogComponent implements OnInit {
  public user: ILoggedInUserViewModel;
  public loader: boolean;
  public spinnerLoader: boolean;
  public roleList: IRoleViewModel[] = [];
  public assignedRoleList: IAssignedRole[] = [];
  public reassignRolePayload: IAssignRoleViewModel;
  public assignedDefaultRole: string;
  public assignedMultipleRoles: Set<string> = new Set();
  public roleName = RoleName;

  constructor(
    @Inject(MAT_DIALOG_DATA) public editRoleAssignmentPayload: { memberDetail: ViewMemberModel; roleType: string },
    private _vendorService: VendorService,
    private _memberService: MemberService,
    private _toaster: ToastrService,
    private _dialogRef: MatDialogRef<ReassignRoleDialogComponent>,
    private _headerService: HeaderService,
  ) {}

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.spinnerLoader = true;
    this.getRoleDetail();
  }

  private getRoleDetail() {
    forkJoin([
      this._vendorService.getAllRole(this.editRoleAssignmentPayload.roleType),
      this._memberService.getAssignedRoleListBasedOnMemberId(
        this.editRoleAssignmentPayload.memberDetail.memberId,
        this.editRoleAssignmentPayload.memberDetail.businessUnitId,
      ),
    ]).subscribe(
      ([allRoleResponse, assignedRoleResponse]) => {
        this.roleList = allRoleResponse;
        this.assignedRoleList = assignedRoleResponse;
        this.assignedDefaultRole = this.assignedRoleList.find((role) => role.isDefaultRole)?.roleId;
        this.assignedRoleList.forEach((role) => {
          this.assignedMultipleRoles.add(role.roleId);
        });
        this.spinnerLoader = false;
      },
      (error) => {
        this.spinnerLoader = false;
        console.log(error);
        this._toaster.warning('Error occurred while fetching data!', 'Warning', { positionClass: 'toast-top-center', timeOut: 6000 });
      },
    );
  }

  selectMultipleRole(event: any) {
    if (event.target.checked) {
      this.assignedMultipleRoles.add(event.target.value as string);
    } else {
      this.assignedMultipleRoles.delete(event.target.value as string);
    }
  }

  disableAdminRoleSelectionForInvalidEmail(role: IRoleViewModel): boolean {
    return (
      !AdminEmailRegEx.trinityDomainRegEx.test(this.editRoleAssignmentPayload.memberDetail.emailID) &&
      !AdminEmailRegEx.srtaDomainRegEx.test(this.editRoleAssignmentPayload.memberDetail.emailID) &&
      role.rolename === RoleName.ExecutiveAdmin
    );
  }

  reassignRole(): void {
    this.loader = true;
    this.reassignRolePayload = {
      memberId: this.editRoleAssignmentPayload.memberDetail.memberId,
      roleList: this.rolePayload(),
      businessUnitId: this.editRoleAssignmentPayload.memberDetail.businessUnitId,
    };

    this._vendorService.reassignRole(this.reassignRolePayload).subscribe(
      (response) => {
        this.loader = false;
        this._toaster.success('Role reassigned successfully.', 'Success', { positionClass: 'toast-top-center', timeOut: 2000 });
        /* This code block is checking if the currently logged in user is the same as the member whose role is
        being reassigned. If they are the same, it updates the assignedRoleList of the user with the new
        roles and saves it in the localStorage. It also triggers the refreshRolesSubject$ observable in the
        HeaderService to notify other components that the roles have been updated. */
        if (this.user.memberId == this.editRoleAssignmentPayload.memberDetail.memberId) {
          this.user.assignedRoleList = [];
          this.reassignRolePayload.roleList.forEach((role) => {
            this.user.assignedRoleList.push({
              roleId: role.roleId,
              roleName: this.roleList.find((roleDetail) => role.roleId == roleDetail.roleid)?.rolename,
              isDefaultRole: role.isDefaultRole,
            });
          });
          localStorage.setItem('user', JSON.stringify(this.user));
          this._headerService.refreshRolesSubject$.next(this.user);
        }
        this._dialogRef.close();
      },
      (error) => {
        this.loader = false;
        console.log('error: ', error);
        this._toaster.warning('Something Went Wrong!', 'Warning', { positionClass: 'toast-top-center', timeOut: 6000 });
      },
    );
  }

  rolePayload(): IAssignedRole[] {
    let rolePayload: IAssignedRole[] = [];
    let roles = Array.from(this.assignedMultipleRoles);
    roles = roles.filter((roleId) => roleId != this.assignedDefaultRole);
    roles.forEach((assignedRoleId) => {
      rolePayload.push({
        roleId: assignedRoleId,
        roleName: null,
        isDefaultRole: false,
      });
    });
    rolePayload.push({
      roleId: this.assignedDefaultRole,
      roleName: null,
      isDefaultRole: true,
    });
    return rolePayload;
  }
}
